import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ROUTES } from '../../../routes/urls';
import { Content, Headerblock, Heading, Icon, Title, Menu as MenuDiv, Headerbtn } from './styles';
import { Modalhead, Headline } from '../../customer/styles';
import CreateNewProjectModalV2 from '../../../component/models/createNewProjectModal/createProjectModelV2';
import ButtonV2 from '../../../component/button/buttonV2';
import ModalCustom from '../../../component/models/modal';
import DeleteModal from '../../../component/models/deleteModel';
import { isEmpty } from 'lodash';
import { Dropdown, DropdownItem } from '../../../component/Dropdown';
import { WorkspaceModel } from '../../../mobx/models/workspace';
import { rootStore } from '../../../mobx/rootStore';
import { useMobileDevice } from '../../../global/useMobile';
import ResponsiveHeader from '../../../component/responsiveHeader/header';
import { menuAllProjectArchiveItems } from '../../../global/row';
import { BUTTON_TYPE } from '../../../global/constants';

interface Props {
  workspaceDetails: WorkspaceModel | undefined | null;
}

const Header: React.FC<Props> = (props) => {
  const { workspaceDetails } = props;

  // States
  const [closeModel, setCloseModel] = useState(false);
  const [isOpen, setOpen] = useState(false);
  //Mobx store variables
  const { projectStore } = rootStore;
  const { createProjectInput } = projectStore;
  const { name, customerId } = createProjectInput || {};
  // Other variables
  const history = useHistory();
  const mobile = useMobileDevice();

  const CloseModal = () => {
    setOpen(false);
    rootStore.projectStore.createProjectInput.clear();
  };

  const Cancel = useCallback(() => {
    if (!isEmpty(name) || customerId) {
      setCloseModel(true);
    } else {
      setOpen(false);
      rootStore.projectStore.createProjectInput.clear();
    }
  }, [customerId, name]);

  const onOnkModel = () => {
    setCloseModel(false);
    setOpen(false);
    rootStore.projectStore.createProjectInput.clear();
  };

  const close = () => {
    setCloseModel(false);
  };

  const renderMoreDropdown = useCallback(() => {
    return (
      (workspaceDetails?.isAdmin || workspaceDetails?.isOwner) && (
        <Dropdown
          modalTitle='More'
          activeClassName='active'
          content={
            <Icon className='dotIcon'>
              <SVGIcon
                name='three-dots-horizontal-icon'
                width='20'
                height='20'
                viewBox='0 0 18 18'
                fill='var(--text-secondary)'
              />
            </Icon>
          }>
          {menuAllProjectArchiveItems.map((item) => {
            return (
              <DropdownItem
                key={item.key}
                label={item.label}
                tone='primary'
                onClick={() => {
                  history.push(ROUTES.ARCHIVE_PROJECT);
                }}
              />
            );
          })}
        </Dropdown>
      )
    );
  }, [history, workspaceDetails?.isAdmin, workspaceDetails?.isOwner]);

  return (
    <>
      {!mobile ? (
        <Content>
          <Headerblock>
            <Heading>
              <Title>All Projects</Title>
            </Heading>
          </Headerblock>
          <MenuDiv>
            <Headerbtn>
              {(workspaceDetails?.isOwner || workspaceDetails?.isAdmin) && (
                <ButtonV2
                  title='New Project'
                  variant={BUTTON_TYPE.PRIMARY}
                  onClick={() => {
                    history.push(ROUTES.CREATE_PROJECT_STEP2);
                  }}
                  iconName='plus-icon'
                  iconPosition='start'
                  buttonType='button'
                  size='small'
                />
              )}
            </Headerbtn>

            {renderMoreDropdown()}
          </MenuDiv>
        </Content>
      ) : (
        <ResponsiveHeader Title='All Projects' leftElement={renderMoreDropdown()} />
      )}
      <ModalCustom open={isOpen} onClose={Cancel} width={632}>
        <Modalhead>
          <Headline>Create New Project</Headline>
          <Icon onClick={Cancel} className='close-icon'>
            <SVGIcon name='close-icon' width='18' height='18' viewBox='0 0 18 18' stroke='var(--text-primary)' />
          </Icon>
        </Modalhead>
        <CreateNewProjectModalV2 onClose={close} handleCloseModal={CloseModal} onClickCancel={Cancel} />
      </ModalCustom>
      <ModalCustom open={closeModel} onClose={close} width={334}>
        <DeleteModal
          isYes={true}
          onClose={close}
          onOk={onOnkModel}
          modalTitle='Confirmation Model'
          description='Are you sure you want close this model?'
        />
      </ModalCustom>
    </>
  );
};

export default Header;
